import configAxios from './config-axios'
import configFilter from './config-filter'

const utils = function () {
  configAxios.init()
  configFilter.init()
}

export default utils



// WEBPACK FOOTER //
// ./src/utils/index.js